<template>
  <div>
    <b-modal
      id="modal-alert-not-fillin"
      size="lg"
      ok-title="Save"
      cancel-title="Cancel"
      centered
      hide-footer
      no-close-on-backdrop
    >
      <template #modal-header="{ close }">
        <div class="d-flex ms-auto" >
          <h5 @click="close()" style="font-size: 2rem">x</h5>
        </div>
      </template>
      <div class="d-grid">
        <img src="@/assets/warning.png" class="mx-auto w-25" />
        <p class="mx-auto mb-1">ไม่อนุญาตให้</p>
        <p class="mx-auto">กรอกข้อมูลล่วงหน้า</p>
        <button
          class="text-bgreen-100 rounded-pill py-2 px-3 w-50 mx-auto mt-3"
          style="border: 1px solid #265054"
          @click="closeModal()"
        >
          Back
        </button>
      </div>
    </b-modal>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  methods: {
    closeModal() {
      this.$bvModal.hide("modal-alert-not-fillin");
    },
  },
};
</script>

<style lang="scss">

#modal-alert-not-fillin {
  border-bottom: none !important;
}
</style>
